import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { MobileView, BrowserView, isMobile, isTablet } from 'react-device-detect'
import ImagePlaceholder from 'core/components/image-placeholder'
import { Card, Row, Col } from 'core/components/ui'
import { greys, fontFamily } from 'assets/themes/theme-default'
import PriceFrom, { SIZE as PriceFromSIZE } from '../price-from'

const { Meta } = Card

const imageDimensions = {
  height: '168px',
  width: '245px'
}
const imageDimensionsMobile = {
  height: '80px',
  width: '70px'
}

const AntCardStyled = styled(Card)`
  &&& {
    box-shadow: ${props => props.selected && `0 2px 15px rgba(0,0,0,0.4)`};
    margin-bottom: 25px;
    background: ${props => (props.selected ? props.theme.colors.color1.bg : greys.light4)};
    .ant-card-cover {
      height: 150px;
    }
    .ant-card-actions {
      background: ${greys.light4};
      color: ${props => props.theme.colors.color1.bg};
      > li > span {
        color: ${greys.dark1};
        :hover {
          color: ${greys.dark1};
        }
      }
    }
    .ant-card-body {
      padding-bottom: ${props => props.borderedTitle && '5px'};
    }
    .ant-card-meta {
      .ant-card-meta-title {
        color: ${props => (props.selected ? greys.light4 : greys.dark1)};
        border: ${props => !props.borderedTitle && '0px none'};
        padding-bottom: ${props => !props.borderedTitle && '0px'};
        margin-bottom: 0px;
        border-color: ${props => props.selected && props.theme.colors.color1.bg};
      }
    }
  }
`

const StyledRow = styled(Row)`
  box-shadow: ${props => props.selected && `0 2px 15px rgba(0,0,0,0.4)`};
  background: ${props => (props.selected ? props.theme.colors.color1.bg : greys.light4)};
  margin: 0 0 0px 0;
  min-height: 80px;
  padding: 10px 0;
  border-bottom: 1px solid ${greys.dark3};
  line-height: normal;
  color: ${props => (props.selected ? greys.light4 : greys.dark1)};
  font-family: ${props => props.theme.fontFamily && `${props.theme.fontFamily.bold.name},`}
    ${fontFamily.bold};
`

const CardVehicle = props => {
  const { vehicle, selected } = props

  if (!vehicle) return null

  const actions = []

  if (vehicle.price)
    actions.push(<PriceFrom value={vehicle.price} size={isMobile && PriceFromSIZE.sm} />)

  const RenderVisuel = () => {
    const selectedImageDimensions = isMobile ? imageDimensionsMobile : imageDimensions
    if (vehicle.urlImage)
      return (
        <img
          src={`${vehicle.urlImage}?width=${selectedImageDimensions.width}&height=${selectedImageDimensions.height}`}
          alt={vehicle.name}
        />
      )

    return (
      <div style={{ height: selectedImageDimensions.height, width: selectedImageDimensions.width }}>
        <ImagePlaceholder />
      </div>
    )
  }

  return (
    <>
      {!isTablet && (
        <BrowserView>
          <AntCardStyled
            selected={selected}
            hoverable
            cover={<RenderVisuel />}
            actions={actions}
            borderedTitle={vehicle.price && true}
          >
            <Meta title={vehicle.name} />
          </AntCardStyled>
        </BrowserView>
      )}
      <MobileView>
        <StyledRow type="flex" align="middle" gutter={50} selected={selected}>
          <Col span={6}>
            <RenderVisuel />
          </Col>
          <Col span={8}>{vehicle.name}</Col>
          <Col span={10}>{actions}</Col>
        </StyledRow>
      </MobileView>
    </>
  )
}

CardVehicle.defaultProps = {
  vehicle: null,
  selected: false
}
CardVehicle.propTypes = {
  vehicle: PropTypes.shape(),
  selected: PropTypes.bool
}

export default CardVehicle
